import { AssessmentAndPlan } from "~/providers/components";

export const LeadPatientAssessmentAndPlan = () => <AssessmentAndPlan />;
